jQuery(document).ready(function($) {
	$(".menuToggle").on('click', function (e) {
		e.preventDefault();
		$("#mainMenu").toggleClass('open');
		$("header.header").toggleClass('menu-open');
		$("body").toggleClass('menu-open');
		$(".menuToggle").toggleClass('active');
		$("header.header .download-reports").toggle();
		// $(this).toggleClass('active');
	})
	$(document).keyup(function(e) {
		if (e.keyCode == 27 && $("#mainMenu").hasClass("open")) {
			$(".menuToggle").click();
		}
	});
	$("#mainMenu ul li.download a").on('click', function (e) {
		e.preventDefault();
		$("#mainMenu").removeClass('open');
		$("#header.header").removeClass('menu-open');
		$("body").removeClass('menu-open');
		$(".menuToggle").removeClass('active');
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 500);
	})
	$(window).scroll(function() {
		if ($(window).scrollTop() >= 60) {
			$(".site-logo, .menuToggle").addClass("scrolled");
		} else {
			$(".site-logo, .menuToggle").removeClass("scrolled");
		}
	});
	
	$(".download-all-reports").on('click', function (e) {
		e.preventDefault();
		$("#mainMenu").removeClass('open');
		$("#header.header").removeClass('menu-open');
		$("body").removeClass('menu-open');
		$(".menuToggle").removeClass('active');
		$("header.header .download-reports").toggle();
		$('html, body').animate({
			scrollTop: $($.attr(this, 'href')).offset().top
		}, 500);
	})
});
